import { render, staticRenderFns } from "./moreList.vue?vue&type=template&id=6244ca00&scoped=true"
import script from "./moreList.vue?vue&type=script&lang=js"
export * from "./moreList.vue?vue&type=script&lang=js"
import style0 from "./moreList.vue?vue&type=style&index=0&id=6244ca00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244ca00",
  null
  
)

export default component.exports